/* eslint-disable no-template-curly-in-string */
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import swal from 'sweetalert';
import { Table, Input, Icon, message, Button, Modal, Popconfirm } from 'antd';
import { connect } from 'react-redux';
import InputField from '../../components/global/InputField';
import { getLanguagesData, getLocaleTranslationData } from '../../actions/index';
import BreadcrumbHeading from '../../components/global/BreadcrumbHeading';
import { Combobox } from 'react-widgets';
import Translation from '../../Translation';
import CelaneseAPI from '../../services';
import config, { utils } from '../../config';
import './TranslationLabels.css';
import store from '../../store';

/**
 * stringSort function is for sorting the strings
 * 
 * @param {string} a 
 * @param {string} b 
 */
const stringSort = (a, b) => {
    if (a < b) { return -1; }
    if (a > b) { return 1; }
    return 0;
}
class EditableCell extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: this.props.value,
            editable: false
        }
    }
    handleChange = (e) => {
        const value = e.target.value;
        this.setState({ value });
    }
    updateInputValue = () => {
        this.setState({ editable: false });
        if (this.props.onChange) {
            this.props.onChange(this.state.value);
        }
    }
    toggleInputView = val => {
        if (typeof val === 'boolean') {
            this.setState({
                editable: val,
                value: val ? this.state.value : this.props.value
            });
        }
    }
    render() {
        const { value, editable } = this.state;
        return (
            <div className="editable-cell">
                {
                    editable ? (
                        <div className="editable-cell-input-wrapper">
                            <Input value={value} onChange={this.handleChange} onPressEnter={this.updateInputValue} />
                            <Icon type="close" className="editable-cell-icon-close" onClick={() => this.toggleInputView(false)} />
                            <Icon type="check" className="editable-cell-icon-check" onClick={this.updateInputValue} />
                        </div>
                    ) : (
                            <div className="editable-cell-text-wrapper">
                                {value || ' '}
                                <Icon type="edit" className="editable-cell-icon" onClick={() => this.toggleInputView(true)} />
                            </div>
                        )
                }
            </div>
        );
    }
}

EditableCell.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func
}


class TranslationTable extends Component {
    constructor(props) {
        super(props);
        let screensList = [
            {
                text: "Tow Item Selection",
                value: 'menu_tow_item_selection',
            },
            {
                text: "Filter & Cigarette Design",
                value: 'menu_filter_and_cigarette_design',
            },
            {
                text: "Tools",
                value: 'menu_items_tools',
            },
            {
                text: "Admin",
                value: 'menu_items_admin',
            },
            {
                text: "EPD Bias",
                value: 'lbl_epd_bias',
            },
            {
                text: "Firmness Tester Conversion",
                value: 'title_tools_firmsness_tester',
            },
            {
                text: "Tip Ventilation Calculation",
                value: 'title_tip_ventilation_calculation',
            },
            {
                text: "Share Filter Cigarette",
                value: 'menu_item_tools_epd_share_filter_cigarette',
            },
            {
                text: "Delete Obsolete Designs",
                value: 'title_tools_delete_obsolete',
            },
            {
                text: "Manage Tow Items",
                value: 'title_admin_manage_tow_items',
            },
            {
                text: "Manage Companies",
                value: 'title_admin_manage_company',
            },
            {
                text: "Manage Messages",
                value: 'title_admin_manage_messages',
            },
            {
                text: "Model Analyzer",
                value: 'title_admin_modal_analyzer',
            },
            {
                text: "Translation Labels",
                value: 'title_admin_translation_labels',
            },
            {
                text: "Common",
                value: 'lbl_common',
            }
        ];
        let screenNames = [];
        for(let i = 0; i < screensList.length; i++) {
            let screenName = screensList[i];
            screenNames.push({
                text: <Translation labelName={screenName.value} defaultText={screenName.text} />,
                value: screenName.value
            });
        }
        let columns = [{
            title: <Translation labelName="tbl_hdr_label_name" defaultText="Label Name" />,
            dataIndex: 'labelName',
            key: 'labelName',
            defaultSortOrder: 'ascend',
            sorter: (a, b) => stringSort(a['labelName'], b['labelName']),
            filterDropdown: this.filterDropdown,
            onFilterDropdownVisibleChange: this.onFilterDropdownVisibleChange,
            tableRender: this.tableRender,
            onFilter: (value, record) => record['labelName'].toString().toLowerCase().includes(value.toLowerCase())
        },
        {
            title: <Translation labelName="tbl_hdr_screen_name" defaultText="Screen Name" />,
            dataIndex: 'screenName',
            key: 'screenName',
            nocustomfilter: true,
            filters: screenNames,
            sorter: (a, b) => stringSort(a['screenName'], b['screenName']),
            onFilter: (value, record) => record['screenName'].toString().toLowerCase().includes(value.toLowerCase()),
            render: (text, rec) => {
                return <Translation labelName={rec.screenName} defaultText={rec.screenName} />
            }
        },
        {
            title: 'English',
            dataIndex: 'English',
            key: 'English',
            sorter: (a, b) => stringSort(a['English'], b['English']),
            filterDropdown: this.filterDropdown,
            onFilterDropdownVisibleChange: this.onFilterDropdownVisibleChange,
            tableRender: this.tableRender,
            onFilter: (value, record) => record['English'].toString().toLowerCase().includes(value.toLowerCase()),
            render: (text, record) => {
                return (<EditableCell value={text} onChange={this.onCellChange(record.key, 'English')} />);
            }
        },
        {
            title: '中文',
            dataIndex: 'Chinese',
            key: 'Chinese',
            sorter: (a, b) => stringSort(a['Chinese'], b['Chinese']),
            filterDropdown: this.filterDropdown,
            onFilterDropdownVisibleChange: this.onFilterDropdownVisibleChange,
            tableRender: this.tableRender,
            onFilter: (value, record) => record['Chinese'].toString().toLowerCase().includes(value.toLowerCase()),
            render: (text, record) => {
                return (<EditableCell value={text} onChange={this.onCellChange(record.key, 'Chinese')} />);
            }
        }];
        let languageColumns = [{
            title: 'Language Name',
            dataIndex: 'languageName',
            key: 'languageName',
            tableRender: this.tableRender,
            render: (text, record) => {
                return record.languageName;
            }
        }, {
            title: 'Language Code',
            dataIndex: 'languageCode',
            key: 'languageCode',
            tableRender: this.tableRender,
            render: (text, record) => {
                return record.languageCode;
            }
        },{
            title: 'Translation',
            dataIndex: 'translation',
            key: 'translation',
            tableRender: this.tableRender,
            render: (text, record) => {
                return (<EditableCell value={record.translation} onChange={this.onTranslationChange(record.languageName, 'English')} />);
            }
        },{
            title: <Translation labelName="lbl_action" defaultText="Action"/>,
            key: 'action',
            width: 100,
            nocustomfilter: true,
            render: (rec) => {
                if (!((rec.languageName || '').toLowerCase() === 'english' || (rec.languageName || '').toLowerCase() === 'chinese')) {
                    return (
                        <span>
                            <Popconfirm title={<Translation labelName="msg_are_sure_want_dlt_lang" defaultText="Are you sure, do you want delete this language?"/>} placement="topRight" icon={<Icon type="question-circle-o" style={{ color: 'red' }} />} onConfirm={(e) => this.confirmDeleteAction(e, rec)} onCancel={this.cancelAction} okText={<Translation labelName="lbl_yes" defaultText="Yes"/>} cancelText={<Translation labelName="lbl_no" defaultText="No"/>}>
                                <a className="table-links" href="#"><Translation labelName="btn_delete" defaultText="Delete"/></a>
                            </Popconfirm>
                        </span>
                    )
                }
                return '';
            }
        }];
        this.state = {
            loading: true,
            parsedLangData: [],
            columns,
            searchText: [],
            showAddLanguage: false,
            languageColumns,
            languagesData: [],
            languageName: '',
            languagesJSON: [],
            newLanguageError: '',
            showAddTranslation: false,
            screenNames,
            screensList,
            translationScreen: '',
            englishTranslation: '',
            languageTranslation: ''
        };
    }

    /**
     * @function onCellChange is for updating the value for the particular label & the language provided
     * @param {string} labelName gets label name from the editable cell component
     * @param {string} dataIndex gets language for the selected row
     * @memberof TranslationTable
     */
    onCellChange = (labelName, dataIndex) => {
        return (value) => {
            const { parsedLangData } = this.state;
            const selLangItem = parsedLangData.find(item => item.key === labelName);
            if (selLangItem) {
                this.setState({
                    loading: true
                })
                let dataObj = {
                    translationLabel: labelName,
                    translationLanguage: dataIndex,
                    translationText: value
                };
                CelaneseAPI.post(config.API.languageTranslations, dataObj).then(res => {
                    if (!res.error) {
                        store.dispatch({
                            type: 'LANGUAGE_DATA',
                            languagesData: res.data
                        });
                        this.setState({
                            loading: false
                        })
                        message.success(utils.getTranslationText('msg_sucessfully_changed_label_name_lang', "Successfully Changed '${labelName}' label for '${language}' Language").replace('${labelName}', labelName).replace('${language}', dataIndex), 1);
                        selLangItem[dataIndex] = value;
                        this.setState({ parsedLangData });
                        this.updateLangContentByPref();
                    } else if (typeof res.error === 'string') {
                        message.error(res.error, 1);
                    }
                }).catch(() => {
                    message.error(utils.getTranslationText('msg_some_issue', 'There was some issue.'), 1);
                });
            }
        };
    }

    onTranslationChange = (langName) => {
        return (value) => {
            let labelName = 'lbl_translation_lang';
            let dataObj = {
                translationLabel: labelName,
                translationLanguage: langName,
                translationText: value
            };
            CelaneseAPI.post(config.API.languageTranslations, dataObj).then(res => {
                if (!res.error) {
                    store.dispatch({
                        type: 'LANGUAGE_DATA',
                        languagesData: res.data
                    });
                    this.updateLangContentByPref();
                } else if (typeof res.error === 'string') {
                    message.error(res.error, 1);
                }
            }).catch(() => {
                message.error(utils.getTranslationText('msg_some_issue', 'There was some issue.'), 1);
            });
        };
    }

    confirmDeleteAction = (e, rec) => {
        e.preventDefault();
        if (rec.languageName) {
            CelaneseAPI.post(config.API.deleteLanguage, {
                "languageName": rec.languageName
            }).then(() => {
                this.getLanguages(true);
            });
        }
    }

    cancelAction = () => {
    }

    /**
     * filterDropdown function is for showing dropdown for each column in the tow items table.
     *
     * @param {Object} opts which is object, it will take selected row keys and user confirmation.
     * @memberof TranslationTable
     */
    filterDropdown = (opts) => {
        let that = this;
        return (
            <div className="custom-filter-dropdown">
                <Input
                    ref={ele => that.searchInput = ele}
                    placeholder={utils.getTranslationText('lbl_filter_text', 'Filter text or =,<,>,=>,<=')}
                    value={opts.selectedKeys[0]}
                    onChange={e => opts.setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={that.handleSearch(opts.selectedKeys, opts.confirm)}
                />
                <Button type="primary" onClick={that.handleSearch(opts.selectedKeys, opts.confirm)}><Translation labelName="lbl_search" defaultText="Search" /></Button>
                <Button onClick={that.handleReset(opts.clearFilters)}><Translation labelName="lbl_reset" defaultText="Reset" /></Button>
            </div>)
    }
    /**
    * onFilterDropdownVisibleChange function is for toggling the search input visibility.
    * 
    * @param {boolean} visible takes boolean as input
    * @memberof TranslationTable
    */
    onFilterDropdownVisibleChange = (visible) => {
        let that = this;
        if (visible) {
            setTimeout(() => {
                that.searchInput.focus();
            });
        }
    }
    /**
     * tableRender function is for rendering of highlighted text.
     * 
     * @param {string} text which will take string as input
     * @memberof TranslationTable
     */
    tableRender = (text) => {
        const { searchText } = this.state;
        return searchText ? (
            <span>
                {text.split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i')).map((fragment, i) => (
                    fragment.toLowerCase() === searchText.toLowerCase()
                        ? <span key={i} className="highlight">{fragment}</span> : fragment // eslint-disable-line
                ))}
            </span>
        ) : text;
    }

    /**
     * handleSearch function is for performing search on the table with selected row keys.
     * @param {array} selectedKeys
     * @param {func} confirmhandler
     * @memberof TranslationTable
     */
    handleSearch = (selectedKeys, confirmhandler) => () => {
        confirmhandler();
        this.setState({ searchText: selectedKeys[0] });
    }

    /**
     * handleReset function is for clearing searched fields on the table.
     * @param {func} clearFilters
     * @memberof TranslationTable
     */
    handleReset = clearFilters => () => {
        clearFilters();
        this.setState({ searchText: '' });
    }

    /**
     * @function getLanguages is for fetching all the languages and constructing the rows & columns
     * @memberof TranslationTable
     */
    getLanguages = (isReload) => {
        this.setState({
            loading: true
        });
        getLanguagesData().then(res => {
            if (res && res.data && res.data instanceof Array) {
                if (isReload) {
                    store.dispatch({
                        type: 'LANGUAGE_DATA',
                        languagesData: res.data
                    });
                }
                let parsedLangData = [];
                let columns = [{
                    title: <Translation labelName="tbl_hdr_label_name" defaultText="Label Name" />,
                    dataIndex: 'labelName',
                    key: 'labelName',
                    defaultSortOrder: 'ascend',
                    sorter: (a, b) => stringSort(a['labelName'], b['labelName']),
                    filterDropdown: this.filterDropdown,
                    onFilterDropdownVisibleChange: this.onFilterDropdownVisibleChange,
                    tableRender: this.tableRender,
                    onFilter: (value, record) => record['labelName'].toString().toLowerCase().includes(value.toLowerCase())
                },
                {
                    title: <Translation labelName="tbl_hdr_screen_name" defaultText="Screen Name" />,
                    dataIndex: 'screenName',
                    key: 'screenName',
                    nocustomfilter: true,
                    filters: [
                        {
                            text: <Translation labelName="menu_tow_item_selection" defaultText="Tow Item Selection" />,
                            value: 'menu_tow_item_selection',
                        },
                        {
                            text: <Translation labelName="menu_filter_and_cigarette_design" defaultText="Filter & Cigarette Design" />,
                            value: 'menu_filter_and_cigarette_design',
                        },
                        {
                            text: <Translation labelName="menu_items_tools" defaultText="Tools" />,
                            value: 'menu_items_tools',
                        },
                        {
                            text: <Translation labelName="menu_items_admin" defaultText="Admin" />,
                            value: 'menu_items_admin',
                        },
                        {
                            text: <Translation labelName="lbl_epd_bias" defaultText="EPD Bias" />,
                            value: 'lbl_epd_bias',
                        },
                        {
                            text: <Translation labelName="title_tools_firmsness_tester" defaultText="Firmness Tester Conversion" />,
                            value: 'title_tools_firmsness_tester',
                        },
                        {
                            text: <Translation labelName="title_tip_ventilation_calculation" defaultText="Tip Ventilation Calculation" />,
                            value: 'title_tip_ventilation_calculation',
                        },
                        {
                            text: <Translation labelName="menu_item_tools_epd_share_filter_cigarette" defaultText="Share Filter Cigarette" />,
                            value: 'menu_item_tools_epd_share_filter_cigarette',
                        },
                        {
                            text: <Translation labelName="title_tools_delete_obsolete" defaultText="Delete Obsolete Designs" />,
                            value: 'title_tools_delete_obsolete',
                        },
                        {
                            text: <Translation labelName="title_admin_manage_tow_items" defaultText="Manage Tow Items" />,
                            value: 'title_admin_manage_tow_items',
                        },
                        {
                            text: <Translation labelName="title_admin_manage_company" defaultText="Manage Companies" />,
                            value: 'title_admin_manage_company',
                        },
                        {
                            text: <Translation labelName="title_admin_manage_messages" defaultText="Manage Messages" />,
                            value: 'title_admin_manage_messages',
                        },
                        {
                            text: <Translation labelName="title_admin_modal_analyzer" defaultText="Model Analyzer" />,
                            value: 'title_admin_modal_analyzer',
                        },
                        {
                            text: <Translation labelName="title_admin_translation_labels" defaultText="Translation Labels" />,
                            value: 'title_admin_translation_labels',
                        },
                        {
                            text: <Translation labelName="lbl_common" defaultText="Common" />,
                            value: 'lbl_common',
                        }
                    ],
                    sorter: (a, b) => stringSort(a['screenName'], b['screenName']),
                    onFilter: (value, record) => record['screenName'].toString().toLowerCase().includes(value.toLowerCase()),
                    render: (text, rec) => {
                        return <Translation labelName={rec.screenName} defaultText={rec.screenName} />
                    }
                }];
                let languages = [];
                let languagesData = [];
                let languageNames = {};
                for (let i = 0; i < res.data.length; i++) {
                    let itemData = res.data[i];
                    let itemFound = parsedLangData.find(item => item.labelName === itemData.translationLabel);
                    if (itemFound) {
                        itemFound[itemData.translationLanguage] = itemData.translationText;
                    } else {
                        let parsedData = {
                            key: itemData.translationLabel,
                            labelName: itemData.translationLabel,
                            screenName: itemData.screen
                        };
                        parsedData[itemData.translationLanguage] = itemData.translationText;
                        parsedLangData.push(parsedData);
                    }
                    
                    if (itemData.translationLabel === 'lbl_translation_lang') {
                        languageNames[itemData.translationLanguage] = itemData.translationText;
                    }
                    if (languages.indexOf(itemData.translationLanguage) < 0) {
                        languages.push(itemData.translationLanguage);
                        if (itemData.translationLanguage !== 'Screen Name') {
                            languagesData.push({
                                languageName: itemData.translationLanguage,
                                languageCode: this.getLanguageByText(itemData.translationLanguage),
                                translation: itemData.translationLanguage
                            });
                        }
                    }
                }
                languagesData.forEach(item => {
                    let translation = item['translation'];
                    item['translation'] = languageNames[item['translation']] || translation;
                    columns.push({
                        title: item['translation'],
                        dataIndex: translation,
                        key: translation,
                        sorter: (a,b) => stringSort(a[translation], b[translation]),
                        filterDropdown: this.filterDropdown,
                        onFilterDropdownVisibleChange: this.onFilterDropdownVisibleChange,
                        tableRender: this.tableRender,
                        onFilter: (value, record) => record[translation].indexOf(value) >= 0,
                        render: (text, record) => {
                            return (<EditableCell value={text} onChange={this.onCellChange(record.key, translation)} />);
                        }
                    });
                });
                this.setState({
                    parsedLangData,
                    loading: false,
                    columns,
                    languagesData
                });
            }
        });

        CelaneseAPI.get(config.API.languageCodes).then(resp => {
            if (resp && resp.data) {
                this.setState({
                    languagesJSON: resp.data
                });
            }
        });
    }

    getLanguageByText = function(text, isCode) {
        let fieldName = isCode ? 'code' : 'text';
        let finalFieldName = isCode ? 'text' : 'code';
        let languageCode = this.state.languagesJSON.find(item => item[fieldName].toUpperCase() === text.toUpperCase());
        if (languageCode) {
            return languageCode[finalFieldName];
        } else {
            let closeLanguage = this.state.languagesJSON.find(item => item[fieldName].toUpperCase().indexOf(text.toUpperCase()) === 0);
            return closeLanguage ? closeLanguage[finalFieldName] : text;
        }
    };

	/**
     * chooseFile function is for initial check for the user that it will override the existing DB, on
     * user confirmation the file will be imported.
     *
     * @param {*} e
     * @memberof TranslationTable
     */
    chooseFile(e) {
        e.preventDefault();
        swal({
            title: utils.getTranslationText('msg_are_u_sure', 'Are you sure?'),
            text: utils.getTranslationText('msg_existing_db', 'This will override the existing DB.'),
            icon: 'warning',
            buttons: [utils.getTranslationText('btn_cancel', 'Cancel'), utils.getTranslationText('btn_continue', 'Continue')],
            dangerMode: true,
        }).then((confirm) => {
            if (confirm) {
                document.querySelector('#file-import').click();
            }
        });
    }

    /**
     * importFile function is for importing the translation. At first we validate the sheet, 
     * if it succeeds then we proceed with importing the excel
     *
     * @returns
     * @memberof TranslationTable
     */
    importFile() {
        let inputElem = document.querySelector('input[type="file"]');
        let extenstion = inputElem.value.split('.xls')[1];
        if (!inputElem.value)
            return;
        if ((extenstion === 'x' || extenstion === '')) {
            swal({
                text: utils.getTranslationText('msg_validating_sheet', 'Validating Sheet...'),
                buttons: false,
                className: 'import-btn-swal'
            });
            const files = inputElem.files;
            const formData = new FormData();
            for (let i = 0; i < files.length; i++) {
                let file = files[i];
                formData.append('file', file);
            }
            inputElem.value = '';

            CelaneseAPI.post(config.API.importTranslation, formData, { isUpload: true }).then(resp => {
                if (!resp.data && resp.error) {
                    let errorText = utils.getTranslationText('msg_invalid_sheet', 'Invalid Sheet');
                    if (resp.validation && resp.validation.sheetNotFound) {
                        errorText = utils.getTranslationText('msg_sheet_not_found_or_invaild"', 'Sheet not Found or Invalid File Format');
                    } else if (resp.validation && resp.validation.masterKeyMismatch) {
                        errorText = utils.getTranslationText('msg_invalid_sheet_master_key_data', 'Invalid Sheet! Master key data mismastch. Please check the list and upload again');
                    }
                    swal({
                        text: errorText,
                        buttons: utils.getTranslationText('btn_ok', 'OK')
                    });
                } else {
                    swal({
                        title: utils.getTranslationText('msg_import_success', 'Import Successful'),
                        text: utils.getTranslationText('msg_Importing_translation_sheet_done_successfully', 'Importing Translation sheet is done successfully'),
                        buttons: utils.getTranslationText('btn_ok', 'OK'),
                        timer: 3000
                    });
                    this.setState({
                        parsedLangData: []
                    });
                    this.getLanguages();
                    this.updateLangContentByPref();
                }
            });
        } else {
            swal({
                text: utils.getTranslationText('msg_excel_files_only', 'Excel files only'),
                buttons: utils.getTranslationText('btn_ok', 'OK')
            });
        }
    }

	/**
     * exportFile function is for initial check for the user to proceed further or not in case when there are no companies.
     *
     * @param {*} e here e is event passed as event
     * @memberof TranslationTable
     */
    exportFile = (e) => {
        e.preventDefault();
        if (this.state.parsedLangData.length === 0) {
            swal({
                text: utils.getTranslationText('msg_data_translation', 'Database has no translations, Do you want to continue to export with empty translations?'),
                buttons: [utils.getTranslationText('lbl_no', 'No'), utils.getTranslationText('lbl_yes', 'Yes')]
            }).then((action) => {
                if (action) {
                    this.downloadFile();
                }
            });
        } else {
            this.downloadFile();
        }
    }

    /**
     * downloadFile function is for downloading translations, in other words it's an exporting feature
     *
     * @memberof TranslationTable
     */
    downloadFile() {
        swal({
            title: utils.getTranslationText('msg_fetching_translation', 'Fetching translations'),
            text: utils.getTranslationText('msg_download_start_in_few_seconds', 'Download will start in few seconds...'),
            buttons: false
        });
        /**
         * API call for exporting translations in excel format
         */
        CelaneseAPI.getBlob(config.API.exportTranslations).then(resp => {
            if (resp.error) {
                swal({
                    text: resp.error
                });
                return;
            }
            let element = document.getElementById('export-translations-link');
            if (document.body.classList.contains('ie11')) {
                window.navigator.msSaveOrOpenBlob(resp, 'translations-' + new Date().getTime() + '.xlsx');
                swal.close();
            } else {
                element.setAttribute('href', window.URL.createObjectURL(resp));
                element.setAttribute('download', 'translations-' + new Date().getTime() + '.xlsx');
                setTimeout(() => {
                    element.click();
                    swal.close();
                }, 1000);
            }
        });
    }

    /**
     * @function updateLangContentByPref is for updating the whole content of the page with respect to the preferences selected by the user.
     * @memberof TranslationTable
     */
    updateLangContentByPref = () => {
        const language = this.props.prefData && this.props.prefData.preferences ? this.props.prefData.preferences.language : '';
        if (language) {
            getLocaleTranslationData(language);
        }
    }

    componentWillMount() {
        this.getLanguages();
    }

    showAddLanguageModal = () => {
        this.setState({
            showAddLanguage: true,
            languageName: '',
            languageTranslation: ''
        })
    }

    showAddTranslationModal = () => {
        this.setState({
            showAddTranslation: true
        });
    }

    saveNewLanguage = () => {
        let languageCode = this.getLanguageByText(this.state.languageName);
        CelaneseAPI.post(config.API.addNewLanguage, {
            languageName: this.state.languageName,
            languageCode,
            languageTranslation: this.state.languageTranslation
        }).then(resp => {
            if (resp) {
                if (resp.error) {
                    this.setState({
                        newLanguageError: resp.error
                    });
                } else {
                    this.setState({
                        showAddLanguage: false,
                        languageName: ''
                    }, () => {
                        this.getLanguages(true);
                    });
                }
            } else {
                this.setState({
                    showAddLanguage: false,
                    languageName: ''
                });
            }
        });
    }

    saveNewTranslation = () => {
        let labelName = this.state.labelName;
        let dataObj = {
            translationLabel: labelName,
            translationLanguage: 'English',
            translationText: this.state.englishTranslation,
            screen: this.state.translationScreen
        };
        CelaneseAPI.post(config.API.languageTranslations, dataObj).then(res => {
            if (!res.error) {
                store.dispatch({
                    type: 'LANGUAGE_DATA',
                    languagesData: res.data
                });
                this.setState({
                    loading: false,
                    labelName: '',
                    englishTranslation: '',
                    translationScreen: '',
                    showAddTranslation: false
                })
                message.success(utils.getTranslationText('msg_sucessfully_added_label_name_lang', "Successfully Added '${labelName}' label for '${language}' Language").replace('${labelName}', labelName).replace('${language}', 'English'), 1);
                this.updateLangContentByPref();
            } else if (typeof res.error === 'string') {
                message.error(res.error, 1);
            }
        }).catch(() => {
            message.error(utils.getTranslationText('msg_some_issue', 'There was some issue.'), 1);
        });
    }


    render() {
        const { loading, parsedLangData, columns, languageColumns, languagesData } = this.state;
        let ListItem = ({ item }) => (
            <Fragment>
                { item.text }
            </Fragment>
        );
        return (
            <Fragment>
                <div className="language-trans-wrapper">
                    <div className="language-trans__header">
                        <BreadcrumbHeading heading={<Translation labelName="langtrans_title" defaultText="Language Translations" />} />
                        <div className="language-trans__header-links">
                            <button type="button" onClick={(e) => this.showAddTranslationModal(e)} className="btn btn-default hide-elem">
                                <Translation labelName="btn_add_translation" defaultText="Add Translation" />
                            </button>
                            <button type="button" onClick={(e) => this.showAddLanguageModal(e)} className="btn btn-default">
                                <Translation labelName="btn_add_language" defaultText="Add Language" />
                            </button>
                            <button type="button" onClick={(e) => this.chooseFile(e)} className="btn btn-default">
                                <Translation labelName="btn_import" defaultText="Import" />
                            </button>
                            <button type="button" className="btn btn-default export-file-btn" onClick={(e) => this.exportFile(e)}><Translation labelName="btn_export" defaultText="Export" /></button>
                            <input id="file-import" onChange={(e) => this.importFile(e)} type='file' accept='.xls,.xlsx' />
                        </div>
                    </div>
                    <div className="language-trans__content">
                        <div className="language-trans__table">
                            <div className="language-trans__table-languages">
                                <Table
                                    bordered
                                    dataSource={languagesData}
                                    columns={languageColumns}
                                    pagination={{ pageSize: 100 }}
                                    loading={loading}
                                />
                            </div>
                            <Table
                                bordered
                                dataSource={parsedLangData}
                                columns={columns}
                                pagination={{ pageSize: 100 }}
                                loading={loading}
                            />
                        </div>
                    </div>
                    <a href="" className="export-translations-hidden" id="export-translations-link" download=""></a>
                </div>
                {
                    this.state.showAddLanguage && 
                    (
                        <Modal
                            className="update-role-company"
                            title={ <Translation labelName="title_create_language" defaultText="Create Language"/> }
                            visible={this.state.showAddLanguage}
                            okText={
                                this.state.isAdd ?
                                <Translation labelName="btn_save" defaultText="Submit"/> :
                                <Translation labelName="btn_save" defaultText="Save"/> 
                            }
                            onOk={this.saveNewLanguage}
                            onCancel={() => { this.setState({ showAddLanguage: false })}}
                            centered
                            width='550px'
                        >
                            <div>
                                {
                                    this.state.newLanguageError && (
                                        <div className="error-text">
                                            { this.state.newLanguageError }
                                        </div>
                                    )
                                }
                            </div>
                            <div className="row">
                                <div className="col-sm-6">
                                    <InputField
                                        type='text'
                                        label={<Fragment><Translation labelName="lbl_languagename" defaultText="Language name "/>*</Fragment>}
                                        name='languageName'
                                        id='languageName'
                                        value={this.state.languageName}
                                        onChange={(e) => { this.setState({ languageName: e.target.value}); }}
                                    />
                                </div>
                                <div className="col-sm-6">
                                    <InputField
                                        type='text'
                                        label={<Fragment><Translation labelName="lbl_lang_trans" defaultText="Language Translation"/>*</Fragment>}
                                        name='languageTranslation'
                                        id='languageTranslation'
                                        value={this.state.languageTranslation}
                                        onChange={(e) => { this.setState({ languageTranslation: e.target.value}); }}
                                    />
                                </div>
                            </div>
                        </Modal>
                    )
                }
                {
                    this.state.showAddTranslation && 
                    (
                        <Modal
                            className="update-role-company"
                            title={ <Translation labelName="title_create_translation" defaultText="Create Translation"/> }
                            visible={this.state.showAddTranslation}
                            okText={
                                this.state.isAdd ?
                                <Translation labelName="btn_save" defaultText="Submit"/> :
                                <Translation labelName="btn_save" defaultText="Save"/> 
                            }
                            onOk={this.saveNewTranslation}
                            onCancel={() => { this.setState({ showAddTranslation: false })}}
                            centered
                            width='550px'
                        >
                            <div>
                                {
                                    this.state.newLanguageError && (
                                        <div className="error-text">
                                            { this.state.newLanguageError }
                                        </div>
                                    )
                                }
                            </div>
                            <div className="row">
                                <div className="col-sm-6">
                                    <InputField
                                        type='text'
                                        label={<Fragment><Translation labelName="lbl_translation_label" defaultText="Label name "/>*</Fragment>}
                                        name='labelName'
                                        id='labelName'
                                        value={this.state.labelName}
                                        onChange={(e) => { this.setState({ labelName: e.target.value}); }}
                                    />
                                </div>
                                <div className='col-md-6'>
                                    <label><Translation labelName="tbl_hdr_screen_name" defaultText="Screen Name" />*</label>
                                    <Combobox
                                        caseSensitive={false}
                                        busy={false}
                                        value={this.state.translationScreen}
                                        onChange={(item) => {
                                            this.setState({
                                                translationScreen: item.value
                                            });
                                        }}
                                        data={this.state.screensList}
                                        messages={{
                                            emptyList: <Translation labelName="msg_there_r_no_items_list" defaultText="There are no items in this list"/> ,
                                        }}
                                        textField='text'
                                        valueField='value'
                                        itemComponent={ListItem}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-6">
                                    <InputField
                                        type='text'
                                        label={<Fragment><Translation labelName="lbl_translation_english" defaultText="English"/>*</Fragment>}
                                        name='englishTranslation'
                                        id='englishTranslation'
                                        value={this.state.englishTranslation}
                                        onChange={(e) => { this.setState({ englishTranslation: e.target.value}); }}
                                    />
                                </div>
                            </div>
                        </Modal>
                    )
                }
            </Fragment>
        );
    }
}

const mapStateToProps = ({ loggedUserState, languagesState }) => ({
    prefData: loggedUserState.prefData,
    languagesData: languagesState.languagesData
});

const mapDispatchToProps = dispatch => ({
    getLanguagesData: (data) => dispatch(getLanguagesData(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(TranslationTable);

TranslationTable.propTypes = {
    prefData: PropTypes.object,
    languagesData: PropTypes.any,
    getLanguagesData: PropTypes.func
}



// WEBPACK FOOTER //
// ./src/containers/TranslationLabels/index.js